import { GraphQLItem } from "../../common/scaffolding/types";

export const applySummaryDisplayName = <T extends GraphQLItem>(item: T): T => ({
    ...item,
    displayName: item.internalName || item.displayName,
});
